export default function plannedTx(txFn) {
  let resolve, reject

  const tx = new Promise((res, rej) => {
    resolve = res
    reject = rej
  })

  tx.send = () => {
    txFn()
      .then(resolve)
      .catch(reject)
    return tx
  }

  tx.cancel = () => reject(new Error("Cancelled"))

  return tx
}
